import React, { useState } from "react";
import { BaseModal, IModalInstance, ModalHeader } from "@whatslly/ui-components/modals";
import styles from "./UserGroups.module.scss";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import { useTranslation } from "react-i18next";
import { TextInput } from "@whatslly/ui-components/v2/BaseElements/TextInput";
import { observer } from "mobx-react-lite";
import { UserPermissions } from "@whatslly/commons/granularPermissions";

type AddGroupModalProps = IModalInstance<{ name: string; permissions: UserPermissions; personAutoSyncStatus: string; groupAutoSyncStatus: string }>;

export const AddGroupModal: React.FC<AddGroupModalProps> = observer(({ closeModal }) => {
  const { t } = useTranslation();
  const [name, setName] = useState<string>("");

  return (
    <BaseModal
      className={styles.addGroupModal}
      bodyClassName={styles.body}
      closeOnClickOutside={false}
      closeOnEscape={false}
      closeModal={() => closeModal()}
      header={<ModalHeader closeModal={() => closeModal()}>{t("user_groups.add_group")}</ModalHeader>}
    >
      <div className={styles.text}>{t("user_groups.name")}</div>
      <TextInput paddingInline={"none"} value={name} data-testid="group-name-input" onChange={(e) => setName(e.target.value)} required />
      <ModalButtons
        testId={"modal-buttons-submit-button"}
        onCancel={() => closeModal()}
        isSubmitDisabled={!name}
        onSubmit={() => closeModal({ permissions: UserPermissions.none, name, personAutoSyncStatus: "inherent", groupAutoSyncStatus: "inherent" })}
      />
    </BaseModal>
  );
});
